export const SIZE_GUIDE_STATE = "SIZE_GUIDE_STATE"

export const showSizeGuide = () => ({
    type: SIZE_GUIDE_STATE,
    payload: {
        visible: true
    }
})

export const setSizeGuide = (options) => ({
    type: SIZE_GUIDE_STATE,
    payload: options
})

export const closeSizeGuide = () => ({
    type: SIZE_GUIDE_STATE,
    payload: {
        visible: false
    }
})